export default __webpack_public_path__ + "static/bytte-farge-figma-df8a2a597d1e6b787d66bb995a6bc1d0.png";